import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Wisconsin State Portal": {
    parameters: {
      linkUrls: ["https://whoprs.wisconsin.gov/Account/Login.aspx"],
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: true,
          receipt: true,
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "WI",
  },
};
